if (!customElements.get('cart-drawer-discount')) {
  class CartDrawerDiscount extends HTMLElement {

    static EU_COUNTRIES = [
      'AT','BE','BG','CY','CZ','DE','DK','EE','ES','FI',
      'FR','GR','HR','HU','IE','IT','LT','LU','LV','MT',
      'NL','PL','PT','RO','SE','SI','SK'
    ];

    static EUROPE_SECONDARY = [
      'CH','NO','IS','AL','BA','MD','ME','MK','RS','UA',
      'XK','BY','GE','AM','AZ','TR','LI','AD','MC','SM','VA'
    ];

    constructor() {
      super();
      this.classList.add('hidden');
    }

    connectedCallback() {
      const itemCount = parseInt(this.getAttribute('data-items-count'), 10);

      if (itemCount === 0) {
        this.classList.add('hidden');
        return;
      }

      const country = this.getAttribute('data-country');
      const threshold = this.getThreshold(country);

      // No threshold defined for this country — hide bar
      if (!threshold) {
        this.classList.add('hidden');
        return;
      }

      // Read presentment currency total from DOM — now safe since
      // thresholds are set in each country's local currency
      const cartTotal = this.getCartTotalFromDOM();

      if (cartTotal === null) {
        fetch('/cart.js')
          .then(r => r.json())
          .then(cart => {
            this.render(cart.total_price / 100, threshold);
            this.classList.remove('hidden');
          });
        return;
      }

      this.render(cartTotal, threshold);
      this.classList.remove('hidden');
    }

    getCartTotalFromDOM() {
      const totalEl = document.querySelector('.totals__total-value');
      if (!totalEl) return null;
      const raw = totalEl.textContent.replace(/[^0-9.,]/g, '').replace(',', '.');
      const parsed = parseFloat(raw);
      return isNaN(parsed) ? null : parsed;
    }

    getThreshold(country) {
      // GB
      if (country === 'GB') return { amount: 150, symbol: '£' };

      // US
      if (country === 'US') return { amount: 200, symbol: '$' };

      // AU
      if (country === 'AU') return { amount: 500, symbol: 'A$' };

      // EU
      if (CartDrawerDiscount.EU_COUNTRIES.includes(country)) return { amount: 200, symbol: '€' };

      // Europe secondary
      if (CartDrawerDiscount.EUROPE_SECONDARY.includes(country)) return { amount: 300, symbol: '€' };

      // Explicit ROW countries in local currency (equiv. ~£300)
      if (country === 'CA') return { amount: 545, symbol: 'CA$' };
      if (country === 'NZ') return { amount: 650, symbol: 'NZ$' };
      if (country === 'CN') return { amount: 2760, symbol: '¥' };
      if (country === 'JP') return { amount: 57000, symbol: '¥' };

      // All other ROW — hide bar
      return null;
    }

    render(cartTotal, threshold) {
      const bar = this.querySelector('.om-shipping-bar');
      const fill = this.querySelector('.om-shipping-bar__fill');
      const message = this.querySelector('.om-shipping-bar__message');
      const unlocked = this.querySelector('.om-shipping-unlocked');

      if (!bar || !fill || !message || !unlocked) return;

      if (cartTotal >= threshold.amount) {
        bar.classList.add('hidden');
        unlocked.classList.remove('hidden');
      } else {
        const remaining = Math.ceil(threshold.amount - cartTotal);
        const progress = Math.min((cartTotal / threshold.amount) * 100, 100);

        message.innerHTML = `you're <span>${threshold.symbol}${remaining}</span> away from free shipping`;
        fill.style.width = `${progress}%`;

        bar.classList.remove('hidden');
        unlocked.classList.add('hidden');
      }
    }
  }

  customElements.define('cart-drawer-discount', CartDrawerDiscount);
}